import { useQuery } from "@tanstack/react-query";
import { getRepeats } from "../../services/repeat";

const useGetRepeats = () => {
  return useQuery({
    queryKey: ["repeats"],
    queryFn: getRepeats,
    staleTime: Infinity,
  });
};

export default useGetRepeats;